// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"2bd417fa","47":"2b44a392","343":"eef4b008","453":"11e2babc","493":"97e53118","927":"1e19cd32"}[chunkId] + ".chunk.js";
};